<p-toast></p-toast>
<div class="app-verification-container">
  <p-card styleClass="p-card-shadow">
    <div class="card">
      <h5>{{'MI_AREA_NOOF_BENEFICIARY'| translate}}</h5>
      <p-chart #lineChart type="line" [data]="multiAxisData"></p-chart>
    </div>
    <div class="card">
      <h5>{{'MI_AREA_OF_HARYANA'| translate}}</h5>
      <p-chart #pieChart type="pie" [data]="data" width="300" height="300"></p-chart>
    </div>
  </p-card>
</div>